import './Formulaire Je Candidate/polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminCatalog from './Formulaire Je Candidate/AdminCatalog';
import AdminTemplate from './AdminTemplate';
import AdminDossiers from './AdminDossiers';
// TEMPORAIRE (test candidature) : @simplewebauthn/browser absent de node_modules
// fait planter tout le bundle. Restaurer cette ligne après installation du paquet.
// import AdminExchanges from './exchanges/AdminExchanges';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/admin/catalog" element={<AdminCatalog />} />
        <Route path="/admin/template" element={<AdminTemplate />} />
        <Route path="/admin/dossiers" element={<AdminDossiers />} />
        {/* TEMPORAIRE (test candidature) : voir import commenté ci-dessus */}
        {/* <Route path="/admin/echanges" element={<AdminExchanges />} /> */}
        <Route path="/*" element={<App />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
